import cn from 'classnames';
import { useState } from 'react';
import ImageViewer from 'react-simple-image-viewer';
import PostingsApi from '../../../../API/shipment/postings-api';
import default_image from '../../../../assets/media/icons/products.png';
import { Column, Row, WhiteBlock } from '../../../../components/Basic/Blocks';
import { formDate } from '../../../../components/Basic/Inputs/Date';
import { Text, TextGrey } from '../../../../components/Basic/WrapsStyle';
import PostingStatusWrap from '../../../../components/Shipments/WrapStyle/PostingStatus';
import CommentPostingProductBlock from '../CommentBlock';
import styles from './styles.module.scss';

const COLOR_MARKET = {
  wb: '#6c11c9',
  yandex: 'rgb(193 61 0)',
  ozon: 'rgb(19,79,231)',
  megamarket: 'rgb(13,131,25)',
  kuper: 'rgb(13,131,25)',
};

const InfoBlock = ({ posting = {}, cardsMap = {}, setPosting = {} }) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const [images, setImages] = useState([]);

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  const onChangeProduct = async (id, productId, field, value, action = undefined) => {
    await PostingsApi.changeProductInPosting({ data: { postingNumber: id, productId, field, value, action } }).then((r) => {
      setPosting(r.posting);
      console.log(r.posting);
    });
  };

  const onChangeProductHistory = async (id, historyElementId, action = undefined, value) => {
    await PostingsApi.changeHistoryPosting({ data: { postingNumber: id, historyElementId, value, action } }).then((r) => {
      setPosting(r.posting);

      console.log(r.posting);
    });
  };

  return (
    <WhiteBlock style={{ minWidth: '600px', paddingBottom: '50px' }}>
      <Column>
        <Row>
          <Text fontSize={20} style={{ marginRight: '20px' }}>
            Магазин:
          </Text>
          <TextGrey style={{ fontSize: '20px', color: COLOR_MARKET[posting.market] }}>{posting.shop}</TextGrey>
        </Row>
        <Row>
          <Text fontSize={20} style={{ marginRight: '20px' }}>
            Статус:
          </Text>
          <PostingStatusWrap order={posting} />
        </Row>
        <Row>
          <Text fontSize={20} style={{ marginRight: '20px' }}>
            Дата заказа:
          </Text>
          <Text fontSize={20}>{formDate(posting.dates.created_at)}</Text>
        </Row>
        <Row>
          <Text fontSize={20} style={{ marginRight: '20px' }}>
            Дата плановой отгрузки:
          </Text>
          <Text fontSize={20}>{formDate(posting.dates.shipment_date)}</Text>
        </Row>
        <Column style={{ marginTop: '20px' }}>
          <table>
            <thead>
              <tr>
                <th style={{ width: '150px' }}>Товар</th>

                <th style={{ width: '250px' }}>Количество</th>
                <th style={{ width: '350px' }}>Цена</th>
                <th style={{ width: '350px' }}>Комментарий</th>
              </tr>
            </thead>
            <tbody></tbody>
            {posting.products.map((product, k) => {
              const productCard = cardsMap[product.offer_id] || {};
              const images = productCard.images
                ? productCard.images.length > 0
                  ? productCard.images
                  : [default_image]
                : [default_image];

              return (
                <tr key={k}>
                  <td>
                    <Row>
                      <div className={styles.wrapper}>
                        <img
                          onClick={() => openImageViewer(images)}
                          className={styles.preview}
                          src={images.length > 0 ? images[0] : undefined}
                        />
                      </div>
                      <div className={styles.name}>
                        <div> {`${product.ordered_quantity} x ${product.name}  `}</div>

                        <div className={cn(styles.offer_id, product.status === 'Нет в наличии' && styles.red_text)}>
                          Sku: {product.offer_id}
                        </div>
                      </div>
                    </Row>
                  </td>

                  <td>
                    <Row className={styles.common_quantity} center={true}>
                      <Text fontWeight={600} fontSize={'22px'}>
                        {product.common_quantity}
                      </Text>
                    </Row>
                  </td>
                  <td>
                    <Row className={styles.common_quantity} center={true}>
                      <Text fontWeight={600} fontSize={'22px'}>
                        {product.price}
                      </Text>
                    </Row>
                  </td>

                  <td>
                    <CommentPostingProductBlock
                      posting={posting}
                      offer_id={product.offer_id}
                      onChange={(v) => onChangeProduct(posting.posting_number, product._id, 'comment', v)}
                      onChangeHistory={(historyElementId, action, value) =>
                        onChangeProductHistory(posting.posting_number, historyElementId, action, value)
                      }
                    />
                  </td>
                </tr>
              );
            })}
          </table>
        </Column>
      </Column>
      {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
    </WhiteBlock>
  );
};

export default InfoBlock;
